class ContentSelector {
  constructor(container) {
    this.container = container;
    this.contentItems = document.querySelectorAll('.content-selector__item');
    this.visibleContent = null;
    this.hashTarget = document.querySelector('#hash-area');
  }

  init() {
    for (let item of this.contentItems) {
      const focusableEls = item.querySelectorAll(
        'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]'
      );

      for (let el of focusableEls) {
        el.setAttribute('tabindex', '-1');
      }
    }

    const hash = window.location.hash;

    if (hash) {
      this.handleHash(hash);
    }

    window.addEventListener(
      'hashchange',
      (e) => {
        e.preventDefault();
        const newHash = window.location.hash;
        this.handleHash(newHash);
      },
      false
    );

    this.container.addEventListener('change', (e) => {
      this.visibleContent = e.target.value;
      this.showContent();
    });
  }

  handleHash(hash) {
    if (hash === '#maincontent') {
      return;
    }
    this.visibleContent = hash.replace('#', '');
    this.showContent();
    this.container.value = this.visibleContent;
    this.hashTarget.focus();
  }

  showContent() {
    const targetElement = document.getElementById(this.visibleContent);
    const targetElementHeight = targetElement.scrollHeight;
    const contentSelectorContainer = document.querySelector(
      '.content-selector'
    );
    for (let contentItem of this.contentItems) {
      contentItem.style.maxHeight = 0;

      const otherContentFocusableEls = contentItem.querySelectorAll(
        'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]'
      );

      for (let otherEl of otherContentFocusableEls) {
        otherEl.setAttribute('tabindex', '-1');
      }
    }
    targetElement.style.maxHeight = `${targetElementHeight}px`;

    const targetFocusableEls = targetElement.querySelectorAll(
      'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]'
    );

    for (let targetEl of targetFocusableEls) {
      targetEl.removeAttribute('tabindex');
    }

    window.scroll({
      top:
        contentSelectorContainer.clientHeight +
        contentSelectorContainer.offsetTop,
      left: 0,
      behavior: 'smooth'
    });
  }
}

export default ContentSelector;
